@use '../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.add-new-card-button {
  background: linear-gradient(180deg, #fff 54.17%, #999 144.44%);
}
